import Vue from 'vue'

const state = {
  baseUri: '/botw/main/admin/'
}
const getters = {
}
const actions = {
  situationList: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 전년도 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = {
      orderContractCompSeq: paramData.orderContractCompSeq
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'situationList',
      params: reqData
    }
    console.log('actions situationList axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  // 250820 사업부 요청사항 반영
  searchContractPerYear: function (_context, [paramData, callback]) { // 원격점검자 메인화면 - 최근 5년(총60개월)동안의 유지보수 계약 누적금액/현장수 데이터 표출
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = {
      orderContractCompSeq: paramData.orderContractCompSeq
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'searchContractPerYear',
      params: reqData
    }
    console.log('actions searchContractPerYear axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  prevRegionCheck: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 전월 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = {
      orderContractCompSeq: paramData.orderContractCompSeq
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'prevRegionCheck',
      params: reqData
    }
    console.log('actions prevRegionCheck axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  currRegionCheck: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 금월 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = {
      orderContractCompSeq: paramData.orderContractCompSeq
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'currRegionCheck',
      params: reqData
    }
    console.log('actions currRegionCheck axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  contExpireList: function (_context, [paramData, callback]) { // 계약관리자 메인화면-계약 금월 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = {
      orderContractCompSeq: paramData.orderContractCompSeq
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'contExpireList',
      params: reqData
    }
    console.log('actions contExpireList axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
